<template>
  <span>{{ animatedNumber }}</span>
</template>

<script>
import gsap from 'gsap'

export default {
  props: {
    number: Number
  },
  data() {
    return {
      tweenedNumber: 0
    }
  },
  computed: {
    animatedNumber() {
      return this.tweenedNumber.toFixed(0)
    }
  },
  mounted() {
    this.animateNumber()
  },
  watch: {
    number() {
      this.animateNumber()
    }
  },
  methods: {
    animateNumber() {
      gsap.to(this.$data, { duration: 0.5, tweenedNumber: this.number })
    }
  }
}
</script>
